import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import AdminBreadcrumbs from './AdminBreadcrumbs';

export default function AdminLayout() {
  const { currentUser, adminRole, refreshAdminRole } = useAuth();
  const role = adminRole || 'super_admin';
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <div className="flex min-h-screen">
        <aside className="hidden w-64 shrink-0 border-r border-slate-200 bg-white md:block">
          <AdminSidebar role={role} />
        </aside>
        {drawerOpen ? (
          <div className="fixed inset-0 z-40 md:hidden">
            <button
              type="button"
              className="absolute inset-0 bg-black/40"
              aria-label="Close"
              onClick={() => setDrawerOpen(false)}
            />
            <aside className="relative z-50 h-full w-64 bg-white shadow-xl">
              <div className="flex justify-end p-2">
                <button type="button" onClick={() => setDrawerOpen(false)} className="p-2">
                  <X className="h-5 w-5" />
                </button>
              </div>
              <AdminSidebar role={role} onNavigate={() => setDrawerOpen(false)} />
            </aside>
          </div>
        ) : null}
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-center gap-2 bg-white md:block">
            <button
              type="button"
              className="p-3 md:hidden"
              onClick={() => setDrawerOpen(true)}
              aria-label="Menu"
            >
              <Menu className="h-5 w-5" />
            </button>
            <div className="min-w-0 flex-1">
              <AdminHeader
                email={currentUser?.email}
                role={role}
                onRefreshRole={refreshAdminRole}
              />
            </div>
          </div>
          <AdminBreadcrumbs />
          <main className="flex-1 p-4">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
